import { render } from "./PrescriberProfileDetails.vue?vue&type=template&id=a3ffa8cc&scoped=true"
import script from "./PrescriberProfileDetails.vue?vue&type=script&lang=js"
export * from "./PrescriberProfileDetails.vue?vue&type=script&lang=js"

import "./PrescriberProfileDetails.vue?vue&type=style&index=0&id=a3ffa8cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ffa8cc"]])

export default __exports__